import { Box, Flex } from '@chakra-ui/react'
import { Select } from './Select'
const valuesArray = (length) =>
    Array.from({ length }, (_, i) => ({ value: ('0' + i).slice(-2), label: ('0' + i).slice(-2) }))

export const TimeSelect = ({ value = '00:00', onChange, ...props }) => {
    const [hour, minute] = value.split(':')

    return (
        <Flex {...props}>
            <Select placeholder={`${props.type} hh`} width={'135px'} onChange={(o) => onChange(`${o.value}:${minute}`)} options={valuesArray(24)} />
            <Box sx={{ fontSize: '32px', lineHeight: '32px' }} alignItems="center" mx={2}>
                :
            </Box>
            <Select placeholder={`${props.type} mm`} width={'135px'} onChange={(o) => onChange(`${hour}:${o.value}`)} options={valuesArray(60)} />
        </Flex>
    )
}
